import { useState, useEffect } from "react";
import { FlaskConical } from "lucide-react";
import api from "@/lib/api";

export default function DevModeBanner() {
  const [on, setOn] = useState(false);

  useEffect(() => {
    let active = true;
    api.get("/auth/mode")
      .then(({ data }) => { if (active) setOn(!!data?.dev_auth_bypass); })
      .catch(() => {});
    return () => { active = false; };
  }, []);

  if (!on) return null;

  return (
    <div data-testid="dev-mode-banner"
      className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[9999] flex items-center gap-2 px-4 py-2 rounded-full
                 border border-amber-500/40 bg-amber-500/10 backdrop-blur-md shadow-lg shadow-black/40">
      <FlaskConical className="w-4 h-4 text-amber-400 shrink-0" />
      <span className="text-xs font-medium text-amber-300 whitespace-nowrap">
        Development Mode – Email verification is bypassed for testing.
      </span>
    </div>
  );
}
